// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-wall-block {
  margin-bottom: 15px;
  --padding-start: 16px;
  --padding-end: 16px;
  --padding-top: 16px;
  --padding-bottom: 16px;
}
.skeleton-wall-block__avatar {
  width: 44px;
  height: 44px;
  margin-inline-end: 12px;
}
.skeleton-wall-block__avatar ion-skeleton-text {
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: 50%;
}
.skeleton-wall-block__label {
  margin: 0;
}
.skeleton-wall-block__line {
  margin: 0 0 8px;
}
.skeleton-wall-block__line ion-skeleton-text {
  margin: 0;
  height: 15px;
}
.skeleton-wall-block__line--name ion-skeleton-text {
  width: 40%;
}
.skeleton-wall-block__line--text ion-skeleton-text {
  width: 88%;
  height: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/wall/skeleton-wall-block/skeleton-wall-block.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AACN;AAGE;EACE,SAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAII;EACE,SAAA;EACA,YAAA;AAFN;AAKI;EACE,UAAA;AAHN;AAMI;EACE,UAAA;EACA,YAAA;AAJN","sourcesContent":[".skeleton-wall-block {\n  margin-bottom: 15px;\n  --padding-start: 16px;\n  --padding-end: 16px;\n  --padding-top: 16px;\n  --padding-bottom: 16px;\n\n  &__avatar {\n    width: 44px;\n    height: 44px;\n    margin-inline-end: 12px;\n\n    ion-skeleton-text {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 50%;\n    }\n  }\n\n  &__label {\n    margin: 0;\n  }\n\n  &__line {\n    margin: 0 0 8px;\n\n    ion-skeleton-text {\n      margin: 0;\n      height: 15px;\n    }\n\n    &--name ion-skeleton-text {\n      width: 40%;\n    }\n\n    &--text ion-skeleton-text {\n      width: 88%;\n      height: 14px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
